import { css } from "@emotion/react";
import { ImageIcon } from "lucide-react";
import type { ImmutableObject } from "@/lib/immutable";
import type { PackageItem, Product } from "../../../hooks/useInventoryState";

const THUMBNAIL_SIZE = 48;

export type ShoppingCartPackageItemImageProps = {
	product: ImmutableObject<Product>;
	packageItem: ImmutableObject<PackageItem>;
};

export const ShoppingCartPackageItemImage: React.FC<
	ShoppingCartPackageItemImageProps
> = ({ packageItem }) => {
	const image = packageItem.Images?.[0];

	return (
		<div
			className="package-item-thumbnail"
			css={css`
				width: ${THUMBNAIL_SIZE}px;
				height: ${THUMBNAIL_SIZE}px;
				display: flex;
				align-items: center;
				justify-content: center;
				overflow: hidden;
				border-radius: 0.25rem;
				background: rgba(148, 163, 184, 0.08);
			`}
		>
			{image ? (
				<img
					src={image.Url}
					alt=""
					css={css`
						width: 100%;
						height: 100%;
						object-fit: contain;
					`}
				/>
			) : (
				<ImageIcon
					aria-hidden="true"
					css={css`
						width: 70%;
						height: 70%;
						color: #777777;
					`}
				/>
			)}
		</div>
	);
};
